export default "__VITE_ASSET__b252006e__"